module.exports = __webpack_public_path__ + "static/media/icon-dropdown.ce295f03.svg";